import React from "react";

/**
 * Round-robin schedule viewer.
 * schedule = [[fix, fix, ...], ...]  // list of rounds
 * playersById = { [user_id]: {first_name, last_name} }
 */
function Name({ pid, playersById }) {
  const u = pid ? playersById[pid] : null;
  return <span className="text-zinc-200">{u ? `${u.first_name || ""} ${u.last_name || ""}`.trim() : "—"}</span>;
}

export default function Schedule({ schedule, playersById = {}, onRecord }) {
  if (!schedule || !schedule.length) return <div className="text-zinc-500 text-sm">No schedule yet. Generate it from the league dashboard.</div>;
  return (
    <div className="space-y-4" data-testid="schedule-view">
      {schedule.map((round, ri) => (
        <div key={`round-${ri}`} className="pp-card p-4">
          <div className="text-xs uppercase tracking-wider text-zinc-500 mb-3">Matchday {ri + 1}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {round.map((fix, mi) => (
              <div key={fix.id} className="flex items-center justify-between bg-[#131313] border border-white/5 rounded-lg px-3 py-2 text-sm" data-testid={`schedule-r${ri}-m${mi}`}>
                <div className="flex items-center gap-2">
                  <Name pid={fix.a} playersById={playersById} />
                  <span className="text-zinc-500">vs</span>
                  <Name pid={fix.b} playersById={playersById} />
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-mono text-zinc-400">{fix.score_a != null ? `${fix.score_a}–${fix.score_b}` : "—"}</span>
                  {onRecord && fix.score_a == null ? (
                    <button data-testid={`schedule-record-r${ri}-m${mi}`} onClick={() => onRecord(ri, mi, fix)} className="text-[#00E676] hover:underline text-xs">Record</button>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
